interface IFooterSectionProps {
    children?: React.ReactNode | React.ReactNode[]
    title: string | React.ReactNode
}

export const FooterSection = ({ children, title }: IFooterSectionProps) => {
    return (
        <div className="flex flex-col">
            <h6 className="text-fg-tertiary mb-s uppercase tracking-widest text-label-sm">
                {title}
            </h6>

            <div className="flex flex-col gap-y-l">{children}</div>
        </div>
    )
}
